import { MapPin, Phone } from "lucide-react";
import { CrownMark } from "./CrownMark";

export const Footer = () => (
  <footer className="border-t border-gold/15 px-5 py-14 sm:px-8" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 text-center">
      <a href="#top" className="flex items-center gap-2.5" data-testid="footer-logo">
        <CrownMark size={30} />
        <span className="font-display text-xl tracking-wide text-cream">
          The Royal <span className="italic text-gold">Cafe</span>
        </span>
      </a>
      <p className="max-w-md text-sm leading-relaxed text-ash">
        Good Food. Good Mood. Royal Experience. Breakfast, lunch and dinner on Anjuna Beach Road, North Goa.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 font-mono text-[0.65rem] uppercase tracking-[0.22em] text-ash">
        <a href="tel:+917358403972" className="flex items-center gap-2 transition-colors hover:text-gold-light" data-testid="footer-phone-link">
          <Phone size={12} className="text-gold" /> 73584 03972
        </a>
        <span className="flex items-center gap-2">
          <MapPin size={12} className="text-gold" /> Anjuna, North Goa, India
        </span>
        <a
          href="https://theroyalcafeanjuna.co"
          target="_blank"
          rel="noreferrer"
          className="text-gold-light transition-colors hover:text-gold"
          data-testid="footer-domain-link"
        >
          TheRoyalCafeAnjuna.co
        </a>
      </div>
      <div className="h-px w-full max-w-xs bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
      <p className="font-mono text-[0.6rem] uppercase tracking-[0.25em] text-ash/60">
        © 2026 The Royal Cafe, Anjuna · All rights reserved
      </p>
    </div>
  </footer>
);
